import React from 'react'
import './LazyLoading.css';

function LazyLoading() {
    return (
        <div className='lazy-loading'>
            <div className='reflector'></div>
        </div>
    )
}

export default LazyLoading;